import { computed, makeObservable, observable } from 'mobx';
import Big from 'big.js';

import { InsuranceProduct } from 'app/model/product/InsuranceProduct';

export class InsuranceListStore {
    @observable
    private _insurance: Array<InsuranceProduct>;

    constructor(insurance: Array<InsuranceProduct>) {
        this._insurance = insurance;
        makeObservable(this);
    }

    @computed
    get hasInsurance(): boolean {
        return !!this._insurance?.length;
    }

    @computed
    get sortedInsuranceList() {
        return this._insurance.slice().sort((a, b) => {
            return new Big(a.amount).cmp(new Big(b.amount));
        });
    }

    /**
     * Возвращает минимальную сумму кредита от которой возможна покупка страхового продукта
     * Возвращает 0, если нет доступных страховых продуктов.
     */
    @computed
    get minInsuranceCreditAmount(): number {
        return this.hasInsurance
            ? this._insurance
                  .map((insurance) => insurance.minCreditAmount)
                  .reduce((acc, value) => (value < acc ? value : acc))
            : 0;
    }

    @computed
    get minAmountInsuranceProducts() {
        return this._insurance.filter(
            (insuranceProduct) =>
                insuranceProduct.minCreditAmount ===
                this.minInsuranceCreditAmount,
        );
    }

    getInsuranceByCode(code: string) {
        return this._insurance.find((insurance) => insurance.code === code);
    }

    getInsuranceByIndex(index: number): InsuranceProduct | undefined {
        return this._insurance?.[index];
    }
}
